
import { ref } from '@nuxtjs/composition-api';


export default {
  props: {
    panels: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    markdown: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const panelModel = ref([])

    return {
      panelModel
    }
  }
}
